const KEY = 'oneapp:return-to';

/** Only paths inside the app, never the sign-in screens themselves or another site ("//evil.example"). */
export function isSafeReturnPath(path: string): boolean {
  return (
    path.startsWith('/') &&
    !path.startsWith('//') &&
    !path.startsWith('/\\') &&
    !/^\/(welcome|sign-in)(\/|$|\?)/.test(path) &&
    path !== '/'
  );
}

/** Remember where someone was going when they had to sign in first. */
export function rememberReturnTo(path: string) {
  if (!isSafeReturnPath(path)) return;
  try {
    window.sessionStorage.setItem(KEY, path);
  } catch {
    // storage blocked: they land in the chat instead
  }
}

export function peekReturnTo(): string | null {
  try {
    const path = window.sessionStorage.getItem(KEY);
    return path && isSafeReturnPath(path) ? path : null;
  } catch {
    return null;
  }
}

export function clearReturnTo() {
  try {
    window.sessionStorage.removeItem(KEY);
  } catch {
    // nothing to clear
  }
}
